/**
 * Cantonese-only words that Intl.Segmenter's Chinese dictionary splits apart
 * (e.g. 我哋 → 我|哋). Adjacent segments matching an entry are merged back.
 * Only list words verified to be split by the segmenter.
 */
export const CANTONESE_WORDS = new Set<string>([
  "我哋",
  "你哋",
  "佢哋",
  "人哋",
  "呢度",
  "嗰度",
  "呢個",
  "嗰個",
  "呢啲",
  "嗰啲",
  "呢排",
  "嗰排",
  "嗰陣",
  "嗰陣時",
  "嗰時",
  "而家",
  "依家",
  "點解",
  "點樣",
  "乜嘢",
  "咩嘢",
  "邊個",
  "邊度",
  "邊啲",
  "邊位",
  "唔該",
  "唔使",
  "唔係",
  "唔好",
  "唔緊要",
  "冇問題",
  "冇事",
  "有冇",
  "係咪",
  "啱啱",
  "頭先",
  "琴日",
  "尋日",
  "聽日",
  "一啲",
  "鍾意",
  "嘢食",
  "做嘢",
  "返學",
  "傾偈",
  "咁樣",
  "噉樣",
  "即係",
  "但係",
  "定係",
  "好彩",
  "搞掂",
  "遲啲",
  "早啲",
]);
